import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

const ProceedSection = ({ isAuthenticated }) => {
  const { t } = useTranslation();

  // Determine the link target based on authentication status
  const targetLink = isAuthenticated ? '/medicalInfo?formType=school-work-form' : '/login';

  return (
    <>
      <section className="py-2">
        <div className="container">
          <h2 className="center p-1">{t('Request Today')}</h2>
          <div className="bottom-line"></div>

          <div className="row">
            <div className="col-lg-8 offset-lg-2">
              <article className="card">
                <div className="text-center p-4">
                  <p className="mb-4">
                    <strong>
                      {t('You will need to register at the Richmond In-Store Medical Clinic to proceed with your form request.')}
                      <br />
                      {t('Click button below to proceed:')}
                    </strong>
                  </p>

                  <div className="mb-4">
                    <Link to={targetLink} className="btn btn-primary btn-lg">
                      {t('FILL OUT MY FORM')}
                    </Link>
                  </div>

                  <p className="text-muted font-italic">
                    {t('We aim to complete most forms within 1-2 business days. For urgent requests, please email')} <a href="mailto:info@instoremed.com">info@instoremed.com</a>.
                  </p>
                </div>
              </article>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

// Map Redux state to props
const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated
});

export default connect(mapStateToProps)(ProceedSection);
